import type { ChartConfig } from './types';
import { THEMES } from './types';

/**
 * チャートのCSS変数を動的に注入するスタイルコンポーネント
 *
 * ChartConfig で定義した color/theme を CSS カスタムプロパティ（--color-*）として注入する。
 * ChartContainer の内部でのみ使用する。
 */
export const ChartStyle = ({ id, config }: { id: string; config: ChartConfig }) => {
  const colorConfig = Object.entries(config).filter(([, config]) => config.theme || config.color);

  if (!colorConfig.length) {
    return null;
  }

  return (
    <style
      // biome-ignore lint/security/noDangerouslySetInnerHtml: shadcn/ui 公式コンポーネント。CSS変数の動的注入に必要
      dangerouslySetInnerHTML={{
        __html: Object.entries(THEMES)
          .map(
            ([theme, prefix]) => `
${prefix} [data-chart=${id}] {
${colorConfig
  .map(([key, itemConfig]) => {
    const color = itemConfig.theme?.[theme as keyof typeof itemConfig.theme] || itemConfig.color;
    return color ? `  --color-${key}: ${color};` : null;
  })
  .join('\n')}
}
`,
          )
          .join('\n'),
      }}
    />
  );
};
